import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css'; // We'll create this file next

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLearnOpen, setIsLearnOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const toggleLearnDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsLearnOpen(!isLearnOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsLearnOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Close dropdown when route changes
  useEffect(() => {
    setIsLearnOpen(false);
  }, [location]);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container">
        <Link className="navbar-brand fw-bold d-flex align-items-center" to="/">
          <img src="/logo.png" alt="StckFuture Logo" height="30" className="me-2" />
          StckFuture
        </Link>
        
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/')}`} to="/" onClick={() => setIsOpen(false)}>
                Home
              </Link>
            </li>
            <li className={`nav-item custom-dropdown ${isLearnOpen ? 'show' : ''}`} ref={dropdownRef}>
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                onClick={toggleLearnDropdown}
                aria-expanded={isLearnOpen}
              >
                Learn
              </a>
              <div className={`custom-dropdown-menu ${isLearnOpen ? 'show' : ''}`}>
                <div className="dropdown-item">
                  <Link to="/fundamentals" onClick={() => setIsOpen(false)}>
                    Stock Market Fundamentals
                  </Link>
                </div>
                <hr className="dropdown-divider" />
                <div className="dropdown-item">
                  <Link to="/investment-basics" onClick={() => setIsOpen(false)}>
                    Investment Basics
                  </Link>
                </div>
                <hr className="dropdown-divider" />
                <div className="dropdown-item">
                  <Link to="/trading-principles" onClick={() => setIsOpen(false)}>
                    Trading Principles
                  </Link>
                </div>
                <hr className="dropdown-divider" />
                <div className="dropdown-item">
                  <Link to="/risk-management" onClick={() => setIsOpen(false)}>
                    Risk Management
                  </Link>
                </div>
                <hr className="dropdown-divider" />
                <div className="dropdown-item">
                  <Link to="/market-analysis" onClick={() => setIsOpen(false)}>
                    Market Analysis
                  </Link>
                </div>
                <hr className="dropdown-divider" />
                <div className="dropdown-item">
                  <Link to="/trading-platforms" onClick={() => setIsOpen(false)}>
                    Trading Platforms
                  </Link>
                </div>
              </div>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/glossary')}`} to="/glossary" onClick={() => setIsOpen(false)}>
                Glossary
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/quiz')}`} to="/quiz" onClick={() => setIsOpen(false)}>
                Quiz
              </Link>
            </li>
            <li className="nav-item">
              <a 
                className="nav-link btn btn-sm btn-success text-white ms-2 px-3" 
                href="https://join.robinhood.com/christm6689" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ borderRadius: '20px', padding: '0.25rem 0.75rem' }}
              >
                Start Investing 🚀
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
